// extracted by mini-css-extract-plugin
export default {"marker-option-img":"special-map-marker-form_marker-option-img__9IymE"};